import { pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core';

import { departments } from './departments';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const smsTemplates = pgTable(
  'sms_templates',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    departmentId: uuid('department_id').references(() => departments.id),
    type: text('type', { enum: ['invite', 'reminder'] }).notNull(),
    language: text('language').notNull(),
    body: text('body').notNull(),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at')
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    unique('sms_templates_unique')
      .on(t.tenantId, t.orgId, t.departmentId, t.type, t.language)
      .nullsNotDistinct(),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
